<template>
  <div id="connection-history">
    <a-form class="ant-advanced-search-form" :form="form" @submit="getInfos">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="Select Date">
            <a-range-picker @change="onDateChange" v-decorator="['range-picker', rangeConfig]" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Charger #">
            <a-input v-decorator="['chargerNumber']" placeholder="All chargers" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8" v-if="!this.SingleCompanyUser">
          <a-form-item label="Company">
            <a-select
              @change="onCompanyChange"
              v-decorator="[
                'company',
                {
                  rules: [{ required: true, message: 'Please select a company!' }]
                }
              ]"
              :allowClear="true"
              placeholder="Select company"
            >
              <a-select-option v-for="(item, index) in displayCompanies" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Location">
            <a-select
              v-decorator="[
                'depot',
                {
                  initialValue: depotList.length == 1 ? depotList[0] : undefined
                }
              ]"
              :allowClear="true"
              placeholder="Select location"
              :disabled="depotDisabled"
            >
              <a-select-option v-for="(item, index) in depotList" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" :style="{ textAlign: 'right' }" :offset="getOffsetValue">
          <a-form-item>
            <a-button type="primary" html-type="submit">
              Generate Report
            </a-button>
            <vue-csv-downloader :data="handleData" :fields="fields" :download-name="csvName">
              <a-button :style="{ marginLeft: '8px' }" type="primary" icon="download" :disabled="downloadDisabled">
                Download Raw CSV
              </a-button>
            </vue-csv-downloader>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <br />
    <div class="search-result-list">
      <div id="components-table-demo-size">
        <a-table
          :columns="outerColumns"
          :dataSource="outsideData"
          :scroll="{ y: 1000 }"
          :rowKey="record => record.clientId"
          :loading="loading"
          :pagination="{
            defaultPageSize: 20,
            showSizeChanger: true,
            position: 'both'
          }"
          @change="onTableChange"
          bordered
          size="middle"
          :expandRowByClick="true"
          :expandedRowRender="expandedRowHandler"
        >
          <div slot="footer">
            <span style="float: left; display: block;">
              {{ this.numberOfRows + " Records Found" }}
            </span>
            <span style="text-align: right; display: block;">
              *Note: Downtime may not be available if the previous Disconnect record is outside selected date range
            </span>
          </div>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import VueCsvDownloader from "vue-csv-downloader";
import { mapState } from "vuex";
import { add, str } from "timelite/time";
export default {
  data() {
    return {
      loading: false,
      downloadDisabled: true,
      depotDisabled: true,
      form: this.$form.createForm(this),
      rangeConfig: {
        rules: [{ type: "array", required: true, message: "Please select Date!" }]
      },
      startTime: "",
      endTime: "",
      csvName: "",
      depotList: [],
      rawData: [],
      numberOfDaysSelected: 0,
      outsideData: [],
      insideDataMap: new Map(),
      numberOfRows: 0,
      pageOffset: 0,
      rawColumns: [
        {
          title: "Index",
          key: "index",
          dataIndex: "index"
        },
        {
          title: "Location",
          dataIndex: "depot"
        },
        {
          title: "Charger Number",
          dataIndex: "chargerNumber"
        },
        {
          title: "GW MAC Address",
          dataIndex: "clientId"
        },
        {
          title: "Event Type",
          dataIndex: "eventType"
        },
        {
          title: "IP Address",
          dataIndex: "ipAddress"
        },
        {
          title: "Disconnect Reason",
          dataIndex: "disconnectReason"
        },
        {
          title: "Timestamp",
          dataIndex: "timestampUtc"
        },
        {
          title: "Downtime (HH:mm:ss)",
          dataIndex: "downtime"
        }
      ]
    };
  },

  components: {
    VueCsvDownloader
  },

  computed: {
    ...mapState(["CognitoUser", "CompanyMap", "SingleCompanyUser"]),

    innnerColumns() {
      const innnerColumns = [
        {
          title: "Event Type",
          dataIndex: "eventType",
          customRender: text => {
            if (text == "connected") {
              return "Connected";
            } else {
              return "Disconnected";
            }
          },
          filters: [
            {
              text: "Connected",
              value: "connected"
            },
            {
              text: "Disconnected",
              value: "disconnected"
            }
          ],
          filterMultiple: false,
          onFilter: (value, record) => record.eventType.indexOf(value) === 0,
          align: "center",
          width: 160
        },
        {
          title: "IP Address",
          dataIndex: "ipAddress",
          customRender: text => {
            if (text == "NO_DATA") {
              return "N/A";
            } else {
              return text;
            }
          },
          align: "center",
          width: 150
        },
        {
          title: "Disconnect Reason",
          dataIndex: "disconnectReason",
          customRender: text => {
            if (text === "N/A") {
              return text;
            } else {
              return this.translateDisconnectReason(text);
            }
          },
          align: "center",
          width: 250
        },
        {
          title: "Timestamp",
          dataIndex: "timestampUtc",
          sorter: (recordOne, recordTwo) => {
            let timeOne = new Date(recordOne.timestampUtc);
            let timeTwo = new Date(recordTwo.timestampUtc);
            return timeOne - timeTwo;
          },
          align: "center",
          width: 160
        },
        {
          title: "Downtime (HH:mm:ss)",
          dataIndex: "downtime",
          sorter: (recordOne, recordTwo) => {
            let timeOne, timeTwo;
            if (recordOne.downtime == "N/A") {
              timeOne = "99:99:99";
            } else if (recordOne.downtime == "Not Available*") {
              timeOne = "99:99:98";
            } else {
              timeOne = recordOne.downtime;
            }
            if (recordTwo.downtime == "N/A") {
              timeTwo = "99:99:99";
            } else if (recordTwo.downtime == "Not Available*") {
              timeTwo = "99:99:98";
            } else {
              timeTwo = recordTwo.downtime;
            }
            return timeOne.localeCompare(timeTwo);
          },
          align: "center",
          width: 160
        }
      ];
      return innnerColumns;
    },

    outerColumns() {
      const outerColumns = [
        {
          title: "Index",
          dataIndex: "index",
          customRender: (text, record, index) => this.pageOffset + index + 1,
          align: "center",
          width: 80
        },
        {
          title: "Location",
          dataIndex: "depot",
          sorter: (recordOne, recordTwo) => recordOne.depot.localeCompare(recordTwo.depot),
          align: "center",
          width: 200
        },
        {
          title: "Charger Number",
          dataIndex: "chargerNumber",
          sorter: (recordOne, recordTwo) => recordOne.chargerNumber - recordTwo.chargerNumber,
          align: "center",
          width: 120
        },
        {
          title: "GW MAC Address",
          dataIndex: "clientId",
          align: "center",
          width: 150
        },
        {
          title: "Total Downtime (HH:mm:ss)",
          dataIndex: "downtime",
          sorter: (recordOne, recordTwo) => {
            let timeOne, timeTwo;
            if (recordOne.downtime == "N/A") {
              timeOne = "99:99:99";
            } else if (recordOne.downtime == "Not Available*") {
              timeOne = "99:99:98";
            } else {
              timeOne = recordOne.downtime;
            }
            if (recordTwo.downtime == "N/A") {
              timeTwo = "99:99:99";
            } else if (recordTwo.downtime == "Not Available*") {
              timeTwo = "99:99:98";
            } else {
              timeTwo = recordTwo.downtime;
            }
            return timeOne.localeCompare(timeTwo);
          },
          customRender: text => {
            if (!(text == "Not Available*" || text == "N/A")) {
              var timeArray = text.split(":");
              var minutes = timeArray[0] * 60 + timeArray[1];
              if (minutes > 10 * this.numberOfDaysSelected) {
                return <b style="color:#f50"> {text} </b>;
              } else {
                return text;
              }
            } else {
              return text;
            }
          },
          align: "center",
          width: 160
        }
      ];
      return outerColumns;
    },

    // CSV fields.
    fields() {
      let fieldsArray = [];
      fieldsArray = this.rawColumns.map(item => {
        return item.dataIndex;
      });
      return fieldsArray;
    },

    handleData() {
      // copy data over, and sort/filter it according to requirements.
      const data = this.rawData;
      data
        .sort((recordOne, recordTwo) => {
          // sort the data by default using the depot and chargerNumber, and return the final data.
          if (recordOne.depot.localeCompare(recordTwo.depot) == 0) {
            return recordOne.chargerNumber - recordTwo.chargerNumber;
          } else {
            return recordOne.depot.localeCompare(recordTwo.depot);
          }
        })
        .forEach((item, index) => {
          if (item.eventType == "connected") {
            item.disconnectReason = "N/A";
            // iterate over the data to find the latest diconnect record for the charger, and calculate the downtime.
            let latestTimestamp = null;
            this.rawData.forEach(disconnectedItem => {
              if (
                disconnectedItem.eventType == "disconnected" &&
                disconnectedItem.clientId == item.clientId &&
                disconnectedItem.timestampUtc < item.timestampUtc
              ) {
                latestTimestamp = disconnectedItem.timestampUtc;
              }
            });
            if (latestTimestamp) {
              const disconnectedTime = this.$moment(latestTimestamp);
              const connectedTime = this.$moment(item.timestampUtc);
              const newDateObject = new Date(connectedTime.diff(disconnectedTime, "seconds") * 1000);
              item.downtime =
                newDateObject
                  .getUTCHours()
                  .toString()
                  .padStart(2, "0") +
                ":" +
                newDateObject
                  .getUTCMinutes()
                  .toString()
                  .padStart(2, "0") +
                ":" +
                newDateObject
                  .getUTCSeconds()
                  .toString()
                  .padStart(2, "0");
            } else {
              item.downtime = "Not Available*";
            }
          } else if (item.eventType == "disconnected") {
            item.downtime = "N/A";
          }
          if (item.timestampUtc) {
            item.timestampUtc = this.$moment(item.timestampUtc)
              .local()
              .format("YYYY-MM-DD HH:mm:ss");
          }
          item.index = index + 1;
          return item;
        });
      // call method to partition the data for the nested table.
      this.partitionData(data);
      return data;
    },

    // function to display the list of companies user is authenticated for.
    displayCompanies() {
      let companyList = [];
      this.CompanyMap.forEach(function(value, key) {
        companyList.push(key);
      });
      return companyList.sort();
    },

    getOffsetValue() {
      if (this.SingleCompanyUser) {
        return 8;
      }
      return 0;
    }
  },

  methods: {
    expandedRowHandler(row) {
      return (
        <a-table
          columns={this.innnerColumns}
          dataSource={this.insideDataMap.get(row.clientId)}
          pagination={false}
          rowKey={(record, index) => index + 1}
        />
      );
    },

    // method to partition the rawData into outer and inner data for the nested table.
    partitionData(rawData) {
      // only proceed if rawData is NOT empty.
      if (rawData.length) {
        let macAddressList = [];
        let outsideData = [];
        let insideDataMap = new Map();
        rawData.forEach(item => {
          // check if the MAC Address is in the macAddressList.
          if (!macAddressList.includes(item.clientId)) {
            // if yes, add it to the macAddressList, create a new outside item as well a new inside item list for the map.
            macAddressList.push(item.clientId);
            let newOutsideItem = {
              depot: item.depot,
              clientId: item.clientId,
              chargerNumber: item.chargerNumber,
              downtime: "00:00:00"
            };
            outsideData.push(newOutsideItem);
            let newList = [];
            let newInsideItem = {
              eventType: item.eventType,
              timestampUtc: item.timestampUtc,
              disconnectReason: item.disconnectReason,
              ipAddress: item.ipAddress,
              downtime: item.downtime
            };
            newList.push(newInsideItem);
            insideDataMap.set(item.clientId, newList);
          } else {
            // if no (means we have already created an outside item for this MAC address, and have a inside item list for it), add to the inside item list.
            let currentList = insideDataMap.get(item.clientId);
            let newInsideItem = {
              eventType: item.eventType,
              timestampUtc: item.timestampUtc,
              disconnectReason: item.disconnectReason,
              ipAddress: item.ipAddress,
              downtime: item.downtime
            };
            currentList.push(newInsideItem);
            insideDataMap.set(item.clientId, currentList);
          }
        });
        // finally, parse the outside data and use the insideDataMap to calculate total downtime for each charger.
        outsideData.forEach(charger => {
          let insideDataList = insideDataMap.get(charger.clientId);
          let totalDowntime = "00:00:00";
          insideDataList.forEach(entry => {
            if (!(entry.downtime == "Not Available*" || entry.downtime == "N/A")) {
              totalDowntime = str(add([totalDowntime, entry.downtime]));
            }
          });
          charger.downtime = totalDowntime;
        });
        this.outsideData = outsideData;
        this.insideDataMap.clear();
        this.insideDataMap = insideDataMap;
        this.numberOfRows = this.outsideData.length;
      }
    },

    getInfos(e) {
      e.preventDefault();
      this.form.validateFields(async (err, fieldsValue) => {
        if (err) {
          return;
        }
        this.rawData = [];
        this.loading = true;
        this.pageOffset = 0;
        this.numberOfDaysSelected = 0;
        const promiseArr = [];
        const rangeValue = fieldsValue["range-picker"];
        const startDay = this.$moment(rangeValue[0]).format("YYYY-MM-DD");
        const endDay = this.$moment(rangeValue[1]).format("YYYY-MM-DD");
        const startTimeUtc = this.$moment(rangeValue[0])
          .startOf("day")
          .utc();
        const endTimeUtc = this.$moment(rangeValue[1])
          .endOf("day")
          .utc();
        const rangeUtc = this.$moment.range(startTimeUtc, endTimeUtc).snapTo("day");
        const daysArray = Array.from(rangeUtc.by("days"));
        // check the size of the daysArray to make sure it is within the allowed range.
        if (daysArray.length > 9) {
          this.$message.error("Range over limit (1 week). Please pick a shorter duration.");
          this.loading = false;
          return;
        }
        this.numberOfDaysSelected = daysArray.length - 1;
        this.csvName = `Connection_History_${startDay}_${endDay}.csv`;
        // iterate through the selected day range and query data for each day (filter by chargerNumber and depot if provided).
        daysArray.forEach(day => {
          let dateTypeDepot = `${day.format("YYYY-MM-DD")}#CON#`;
          let data = {
            dateTypeDepot: dateTypeDepot,
            startTime: startTimeUtc.toJSON(),
            endTime: endTimeUtc.toJSON(),
            chargerNumber: fieldsValue.chargerNumber,
            company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldsValue.company,
            depot: fieldsValue.depot
          };
          promiseArr.push(this.sendData(data));
        });
        try {
          let dataArr = await Promise.all(promiseArr);
          let data = dataArr.flat(Infinity);
          // check if no data is returned; display a message to user in that case.
          if (!data.length) {
            throw new Error("No data available for selected fields!");
          }
          this.rawData = data;
        } catch (error) {
          this.$message.error(error.message);
          this.loading = false;
          return;
        }
        this.loading = false;
        this.downloadDisabled = false;
      });
    },

    async sendData(data) {
      try {
        // add region to the query parameter before making the API call.
        data.region = this.CompanyMap.get(data.company).region;
        let response = await this.$axios.get("https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/chargingus", {
          params: data
        });
        let items = response.data.Items;
        return Promise.resolve(items);
      } catch (error) {
        // if no response is available, means it is a network error.
        if (!error.response) {
          return Promise.reject(new Error("Network Error. Please try again!"));
        } else {
          let response = error.response;
          if (response.status == 400) {
            return Promise.reject(response.data.message);
          }
        }
      }
    },

    onDateChange() {
      this.downloadDisabled = true;
    },

    onCompanyChange(value) {
      this.form.resetFields(["depot"]);
      if (!value) {
        this.depotDisabled = true;
      } else {
        this.depotDisabled = false;
        this.depotList = this.CompanyMap.get(value).depots.sort();
      }
    },

    onTableChange(pagination, filters, sorter, { currentDataSource }) {
      // update the current number of rows in the table, and the page offset.
      this.pageOffset = (pagination.current - 1) * pagination.pageSize;
      this.numberOfRows = currentDataSource.length;
    },

    translateDisconnectReason(disconnectReason) {
      switch (disconnectReason) {
        case "AUTH_ERROR":
          return "The client failed to authenticate or authorization failed. (Please notify Support team)";
        case "CLIENT_INITIATED_DISCONNECT":
          return "Client initiated disconnect.";
        case "CLIENT_ERROR":
          return "Client error. (Please notify Support team)";
        case "CONNECTION_LOST":
          return "The client-server connection is cut off due to loss of internet connection.";
        case "DUPLICATE_CLIENTID":
          return "The client is using a client ID that is already in use. (Please notify Support team)";
        case "FORBIDDEN_ACCESS":
          return "The client is not allowed to be connected. (Please notify Support team)";
        case "MQTT_KEEP_ALIVE_TIMEOUT":
          return "Automatic disconnection due to no client-server communication. Check internet connection.";
        case "SERVER_ERROR":
          return "Server error. (Please notify Support team)";
        case "SERVER_INITIATED_DISCONNECT":
          return "Server initiated disconnect.";
        case "THROTTLED":
          return "The client is disconnected for exceeding a throttling limit. (Please notify Support team)";
        default:
          return "Description not found. (Please notify Support team)";
      }
    }
  },

  created() {
    this.onCompanyChange(this.displayCompanies[0]);
  }
};
</script>
